import { motion } from "motion/react";
import Image from "next/image";
import PortfolioImage from "@/images/projects/portfolio/portfolio.png";
import PortfolioImageDark from "@/images/projects/portfolio/portfolio_dark.png";
import PortfolioMockup from "@/images/projects/portfolio/portfolio_mockup.png";
import PortfolioContact from "@/images/projects/portfolio/contact_light.png";
import PortfolioContactDark from "@/images/projects/portfolio/contact_dark.png";
import Link from "next/link";

const Tech = [
  {
    index: 1,
    name: "NextJS 14",
  },
  {
    index: 2,
    name: "NodeJS",
  },
  {
    index: 3,
    name: "Typescript",
  },
  {
    index: 4,
    name: "Firebase",
  },
  {
    index: 5,
    name: "Framer Motion",
  },
  {
    index: 6,
    name: "Tailwind CSS",
  },
];

export default function Toraverse() {
  return (
    <div className="min-h-screen min-w-full flex items-center flex-col">
      <motion.div
        initial={{
          opacity: 0,
        }}
        whileInView={{
          opacity: 1,
        }}
        transition={{
          type: "spring",
          duration: 3,
        }}
        className="min-h-[25vh] w-[50vw] flex items-end justify-center"
      >
        <Link
          href="/"
          target="_blank"
          className="font-recoleta lg:text-6xl md:text-5xl text-3xl tracking-widest font-bold text-black/60 dark:text-white/60"
        >
          Jignesh Baria
        </Link>
      </motion.div>
      <motion.div
        initial={{
          opacity: 0,
        }}
        whileInView={{
          opacity: 1,
        }}
        transition={{
          type: "spring",
          duration: 3,
        }}
        className="min-h-[25vh] md:w-[50vw] w-full px-2 flex justify-center items-center"
      >
        <div className="font-recoleta lg:text-6xl md:text-5xl text-3xl tracking-widest font-bold text-black dark:text-white text-center">
          Portfolio Website
          <div>
            <Link href="/contact">Hire Me</Link>
          </div>
        </div>
      </motion.div>
      <motion.div
        initial={{
          opacity: 0,
        }}
        whileInView={{
          opacity: 1,
        }}
        transition={{
          type: "spring",
          duration: 3,
        }}
        className="md:mt-[20vh] mt-[10vh] min-w-full md:px-[10%] px-2 group"
      >
        <motion.div
          initial={{
            opacity: 0,
          }}
          whileInView={{
            opacity: 1,
          }}
          whileHover={{
            scale: 1.01,
          }}
          transition={{
            type: "spring",
            duration: 2,
          }}
          className="relative w-full xl:h-[80vh] lg:h-[60vh] md:h-[50vh] h-[40vh]"
        >
          <Image
            src={PortfolioImage}
            alt="PortfolioImage"
            fill
            className="rounded-[50px] transition-all duration-500 ease-in-out object-cover dark:hidden"
          />
          <Image
            src={PortfolioImageDark}
            alt="PortfolioImageDark"
            fill
            className="rounded-[50px] transition-all duration-500 ease-in-out object-cover hidden dark:block"
          />
        </motion.div>
      </motion.div>
      <motion.div
        initial={{
          opacity: 0,
        }}
        whileInView={{
          opacity: 1,
        }}
        transition={{
          type: "spring",
          duration: 3,
        }}
        className="mt-[5vh] min-w-full md:px-[15%] px-2 flex flex-row flex-wrap justify-center items-center gap-4"
      >{Tech.map((item, index) => (
          <motion.div
            initial={{
              opacity: 0,
            }}
            whileInView={{
              opacity: 1,
            }}
            transition={{
              type: "spring",
              duration: 3.5 + (index + 1 / 10),
            }}
            key={item.index}
            className="p-1 px-4 font-poppins font-semibold tracking-wider text-green-950 dark:text-blue-200 lg:text-base text-xs w-fit rounded-full bg-black/10 dark:bg-white/10 backdrop-blur-lg"
          >
            {item.name}
          </motion.div>
        ))}
      </motion.div>
      <motion.div
        initial={{
          opacity: 0,
        }}
        whileInView={{
          opacity: 1,
        }}
        transition={{
          type: "spring",
          duration: 3,
        }}
        className="md:mt-[20vh] mt-[10vh] min-w-full md:px-[15%] px-2 flex flex-col md:items-start items-center gap-8"
      >
        <div className="font-recoleta font-bold tracking-wider md:text-start text-center lg:text-6xl md:text-5xl text-3xl text-black/60 dark:text-white/60">
          About
        </div>
        <div className="font-poppins text-black dark:text-white md:text-start lg:leading-[51px] md:leading-10 leading-9 text-center lg:text-[31px] md:text-[28px] text-[25px] tracking-wide ">
          My portfolio website contain my skills, achievements, and experience.
          I have carefully curated a selection of my best projects to provide
          you with a glimpse of my creative abilities and expertise. Please feel
          free to explore my website and learn more about my background and
          capabilities. I look forward to the opportunity of collaborating with
          you in the future.
        </div>
        <Link
          href={"/"}
          target="_blank"
        >
          <motion.div
            initial={{
              opacity: 0,
            }}
            whileInView={{
              opacity: 1,
            }}
            whileHover={{
              scale: 1.04,
            }}
            whileTap={{
              scale: 0.96,
            }}
            transition={{
              type: "spring",
              duration: 1,
            }}
            title="https://jignesh-baria.vercel.app/"
            className="cursor-pointer select-none tracking-wider p-2 px-4 rounded-full border-2 border-black/30 dark:border-white/30 dark:text-white font-poppins lg:text-xl text-sm"
          >
            Visit Live
          </motion.div>
        </Link>
      </motion.div>
      <motion.div
        initial={{
          opacity: 0,
        }}
        whileInView={{
          opacity: 1,
        }}
        transition={{
          type: "spring",
          duration: 3,
        }}
        className="md:mt-[20vh] mt-[10vh] min-w-full md:px-[10%] px-2 group"
      >
        <motion.div
          initial={{
            opacity: 0,
          }}
          whileInView={{
            opacity: 1,
          }}
          whileHover={{
            scale: 1.01,
          }}
          transition={{
            type: "spring",
            duration: 2,
          }}
          className="relative w-full xl:h-[80vh] lg:h-[60vh] md:h-[50vh] h-[40vh]"
        >
          <Image
            src={PortfolioMockup}
            alt="mobile+descktop"
            fill
            className="rounded-[50px] transition-all duration-500 ease-in-out object-cover"
          />
        </motion.div>
      </motion.div>
      <motion.div
        initial={{
          opacity: 0,
        }}
        whileInView={{
          opacity: 1,
        }}
        transition={{
          type: "spring",
          duration: 3,
        }}
        className="md:mt-[20vh] mt-[10vh] min-w-full md:px-[15%] px-2 flex flex-col md:items-start items-center"
      >
        <div className="font-poppins md:text-start lg:leading-[51px] text-black dark:text-white md:leading-10 leading-9 text-center lg:text-[31px] md:text-[28px] text-[25px] tracking-wide ">
          Every page of the website features a product layout. wThe layout is
          well-organized, with clear navigation menus and sections that guide
          users seamlessly through the site. The typography is clean and easy to
          read, enhancing the overall user experience. The website effectively
          showcases the Toraverse platform and its features, utilizing
          interactive elements and animations to engage users.
        </div>
      </motion.div>
      <motion.div
        initial={{
          opacity: 0,
        }}
        whileInView={{
          opacity: 1,
        }}
        transition={{
          type: "spring",
          duration: 3,
        }}
        className="md:mt-[20vh] mt-[10vh] min-w-full md:px-[10%] px-2 group"
      >
        <motion.div
          initial={{
            opacity: 0,
          }}
          whileInView={{
            opacity: 1,
          }}
          whileHover={{
            scale: 1.01,
          }}
          transition={{
            type: "spring",
            duration: 2,
          }}
          className="relative w-full xl:h-[80vh] lg:h-[60vh] md:h-[50vh] h-[40vh]"
        >
          <Image
            src={PortfolioContact}
            alt="PortfolioContact"
            fill
            className="rounded-[50px] transition-all duration-500 ease-in-out object-cover dark:hidden"
          />
          <Image
            src={PortfolioContactDark}
            alt="PortfolioContactDark"
            fill
            className="rounded-[50px] transition-all duration-500 ease-in-out object-cover dark:block hidden"
          />
        </motion.div>
      </motion.div>
    </div>
  );
}
